import { App } from 'vue';

import AppPage from '@/components/app-page';
import AddressPicker from '@/components/address-picker';
import Pagination from '@/components/pagination';
import PageCard from '@/components/page-card';
import Upload from '@/components/upload/index';
import InputNumber from '@/components/input-number';
import InputNumberRanger from '@/components/input-number-ranger';
import QuerySelect from '@/components/query-select';
import Empty from '@/components/empty';
import Tabs from '@/components/tabs';
import SearchArea from '@/components/search-area';
import HeaderArea from '@/components/header-area';
import DetailTitle from '@/components/detail-title';
import CustomLogs from '@/components/custom-logs';
import DictionarySelect from '@/components/dictionary-select';
import Uploader from '@/components/uploader/index';
import Uploader2 from '@/components/uploader2/index';
import CustomImage from '@/components/custom-image/index';
import RadioCheckbox from '@/components/radio-checkbox';

export default function componentsInstall(app: App) {
  app.use(AppPage);
  app.use(AddressPicker);
  app.use(Pagination);
  app.use(PageCard);
  app.use(Upload);
  app.use(InputNumber);
  app.use(InputNumberRanger);
  app.use(QuerySelect);
  app.use(Empty);
  app.use(Tabs);
  app.use(SearchArea);
  app.use(HeaderArea);
  app.use(DetailTitle);
  app.use(CustomLogs);
  app.use(DictionarySelect);
  app.use(CustomImage);
  app.use(Uploader);
  app.use(Uploader2);
  app.use(RadioCheckbox);
}
